import React, { memo } from 'react';

import { NEGATE_MODES } from '../../../../global/Predicates/Negate';
import Filter, { createFilterChangeHandler } from '../Filter';
import TextField from '../ValueComponents/TextField';

/** @typedef {import('../../../../global/Predicates/Negate').NegateMode} NegateMode */
/** @typedef {import('../../../../global/Predicates/TypeSelector').Type} Type */
/** @typedef {import('../../../../global/Predicates/ComparatorSelector').Comparator} Comparator */

const getDefaultNegate = () => ({ mode: NEGATE_MODES.no });
const getDefaultComparator = (comparators) => comparators[0].value;
const getDefaultValue = () => '';

export const valueMapper = ({ id, ...values }) => ({ ...values });

/**
 *
 * @param {Object} props
 * @param {String} props.id
 * @param {Function} props.onChange
 * @param {String} props.value
 * @param {NegateMode} props.negate
 * @param {String} props.type
 * @param {Type[]} props.types
 * @param {String} props.comparator
 * @param {Comparator[]} props.comparators
 */
const LTVFilter = (props) => {
  const {
    type,
    types,
    value = getDefaultValue(),
    negate = getDefaultNegate(),
    comparators,
    onChange,
    id,
  } = props;

  // Destructure these seperately because we need to know the `type` to get the defaults
  const {
    comparator = getDefaultComparator(comparators),
  } = props;

  const onFilterChange = createFilterChangeHandler({
    id, type, value, negate, comparator, onChange,
  });

  return (
    <Filter
      negate={negate}
      comparator={comparator}
      type={type}
      onChange={onFilterChange}
      types={types}
      comparators={comparators}
      value={(
        <TextField value={value} onChange={onFilterChange} />
      )}
    />
  );
};

export default memo(LTVFilter);
